<template>
    <v-dialog
        :value="dialog"
        persistent
        width="600">
        <v-card class="business-info">
            <h2 class="pt-5 px-10 business-info--title">
                Business information
            </h2>

            <v-form
                ref="form"
                v-model="valid"
                class="px-10 py-5"
                lazy-validation>
                <v-row>
                    <v-col
                        cols="12"
                        sm="6">
                        <v-text-field
                            v-model="formData.firstName"
                            :rules="rules"
                            label="First name*" />
                    </v-col>

                    <v-col
                        cols="12"
                        sm="6">
                        <v-text-field
                            v-model="formData.lastName"
                            :rules="rules"
                            label="Last name*" />
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-model="formData.companyName"
                            :rules="rules"
                            label="Company name*" />
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <phone-number-input
                            v-model="formData.phoneNumber"
                            :label="'Phone number*'"
                            required />
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-model="formData.email"
                            :rules="rules"
                            label="Email address*" />
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-model="formData.address.officeAddress"
                            :rules="rules"
                            label="Office address*" />
                    </v-col>
                </v-row>

                <v-row>
                    <v-col
                        cols="12"
                        sm="4">
                        <v-text-field
                            v-model="formData.address.city"
                            :rules="rules"
                            label="City*" />
                    </v-col>

                    <v-col
                        cols="12"
                        sm="4">
                        <v-select
                            v-model="formData.address.state"
                            :rules="rules"
                            label="State*"
                            autocomplete="on"
                            :items="states" />
                    </v-col>

                    <v-col
                        cols="12"
                        sm="4">
                        <v-text-field
                            v-model="formData.address.zip"
                            :rules="rules"
                            label="Zip*" />
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-model="formData.license"
                            :rules="rules"
                            label="Your ID number*" />
                    </v-col>
                </v-row>

                <v-row
                    class="px-3 mt-5"
                    justify="end">
                    <v-btn
                        text
                        class="mr-5"
                        @click="$emit('close')">
                        Back
                    </v-btn>
                    <v-btn
                        color="primary"
                        tile
                        @click="submit">
                        Finish
                    </v-btn>
                </v-row>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import PhoneNumberInput from '@/components/UI/PhoneNumberInput';
import { validators } from '@/utils/validators';
import { states } from '@/utils/constants';

export default {
    name: 'AppBusinessInfoDialog',

    components: { PhoneNumberInput },

    props: {
        dialog: {
            type: Boolean,
        },
        signUpData: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
            valid: true,
            rules: [(v) => validators.required(v)],
            formData: {
                firstName: this.signUpData.firstName || null,
                lastName: this.signUpData.lastName || null,
                companyName: null,
                phoneNumber: this.signUpData.phoneNumber || '',
                email: this.signUpData.email || null,
                address: {
                    officeAddress: null,
                    city: null,
                    state: null,
                    zip: null,
                },
                license: null,
            },
            states,
        };
    },

    methods: {
        submit() {
            this.$refs.form.validate();

            if (this.valid) {
                this.$emit('finish', {
                    ...this.formData,
                    email: [this.formData.email],
                    license: [this.formData.license],
                    address: [this.formData.address],
                    phoneNumber: [this.formData.phoneNumber],
                });
            }
        },
    },
};
</script>

<style scoped lang='scss'>
.business-info {
    &--title {
        font-size: 22px;
    }

    .row > div {
        padding-top: 0;
        padding-bottom: 0;
    }
}
</style>